import {
  CompaniesInfiniteSelectField,
  FloatingFormItem,
} from '@/components/_common';
import { useDefaultEmptyFieldError } from '@/hooks';
import { Form, Modal, ModalProps } from 'antd';

const WorkOrderChecklistEmptyModal: React.FC<ModalProps> = (props) => {
  const [form] = Form.useForm<{ companyId: string }>();
  const ruleRequired = useDefaultEmptyFieldError();

  async function handleSubmit() {
    try {
      const values = form.validateFields();

      window.open(
        `/privateReports/checklistEmpty?companyId=${(await values).companyId}`,
        '_blank',
      );
    } catch {}
  }

  return (
    <Modal
      {...props}
      title="Selecionar empresa"
      okText="Gerar PDF"
      onOk={handleSubmit}
      destroyOnClose
    >
      <Form form={form} preserve={false}>
        <FloatingFormItem
          name="companyId"
          label="Empresa"
          rules={[ruleRequired]}
        >
          <CompaniesInfiniteSelectField />
        </FloatingFormItem>
      </Form>
    </Modal>
  );
};

export default WorkOrderChecklistEmptyModal;
